import './App.css';
import React, { useEffect } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import Layout from "./views/layout/Layout";
import { clearAccount } from './store/auth/actions';
import store from './store/appStore';


function App(props) {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) {
    return <div>
      {/* Redirecting to Microsoft login... */}
      </div>;
  }

  // Once authenticated → pass account info + logout to Layout
  return (
    <Layout
      {...props}
      accountInfo={accounts[0]}
      logout={() => {
        instance.logoutRedirect();
        store.dispatch(clearAccount());
      }}
    />
  );
}

export default App;
